import React from 'react';

interface DataDelayIndicatorProps {
  className?: string;
  compact?: boolean;
}

const DataDelayIndicator: React.FC<DataDelayIndicatorProps> = ({ 
  className = '', 
  compact = false 
}) => {
  return (
    <div className={`flex items-center text-xs text-gray-400 ${className}`}>
      <div className="flex items-center space-x-1">
        <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></span>
        <span>
          15 min delay
        </span>
      </div>
    </div>
  );
};

export default DataDelayIndicator;